<div class="container-box shadow-none text-center py-5" *ngIf="!connectionError">
  <div class="w-50 m-auto">
    <img src="/assets/images/channel-wizards/complete-icon.webp" alt="" height="50" />
    <h6 class="mt-2" i18n>Property Created Successfully!</h6>
    <p i18n>
      Your property has been successfully created for Booking.com. Review and update property details if needed.
      Configure rates, availability, and policies.
    </p>
    <div class="d-flex gap-3 align-items-center justify-content-center mt-4">
      <button class="btn btn-secondary-primary" (click)="done.emit()">
        <i class="cs-icon cs-icon-check"></i> <ng-container i18n>Complete</ng-container>
      </button>
    </div>
  </div>
</div>

<!-- TV4-5909: property exists on Booking.com but the AdvanceCM connection failed. -->
<div class="container-box shadow-none text-center py-5" *ngIf="connectionError">
  <div class="w-75 m-auto">
    <i class="fas fa-exclamation-triangle fa-2x text-warning"></i>
    <h6 class="mt-2" i18n>Property Created, But Not Connected</h6>
    <p i18n>
      Your property (ID: <b>{{ propertyId }}</b
      >) was created on Booking.com, but AdvanceCM could not set up its connection. Bookings, availability, and rates
      will <b>not</b> sync until the property is connected.
    </p>
    <div class="alert alert-warning text-left" *ngIf="connectionError.error">
      {{ connectionError.error }}
    </div>
    <p i18n>
      Use the Booking.com connect wizard with the property ID above to connect it. The property does not need to be
      created again.
    </p>
    <div class="d-flex gap-3 align-items-center justify-content-center mt-4">
      <button class="btn btn-secondary-info" (click)="connect.emit()">
        <i class="cs-icon cs-icon-link-plus"></i> <ng-container i18n>Connect Now</ng-container>
      </button>
      <button class="btn btn-secondary-primary" (click)="done.emit()">
        <i class="cs-icon cs-icon-check"></i> <ng-container i18n>Close</ng-container>
      </button>
    </div>
  </div>
</div>
